import React from 'react' 
import { CandidateTestComponent } from '@rankmi/ats-app'

const CandidateTestView = ({ userName, data, processName, htmlDescription }) => {
  return <CandidateTestComponent userName={userName} data={data} processName={processName} htmlDescription={htmlDescription}/>
}

export default CandidateTestView